import React from 'react';
import { CustomerAddress } from 'types/Customer';
import { formatCustomerAddress } from 'types/Walking';
import classes from './AddressCard.module.scss';

interface AddressCardProps {
    address: CustomerAddress;
    onChangeAddress: () => void;
}

export const AddressCard: React.FC<AddressCardProps> = ({ address, onChangeAddress }) => {
    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <p className={classes.title}>Your Address</p>
                <button type="button" className={classes.link} onClick={onChangeAddress}>
                    Change
                </button>
            </div>
            <p className={classes.address}>{formatCustomerAddress(address)}</p>
        </div>
    );
};
